import Constants from '../../../utils/Constants';
import image from '../../../assets/imgs/home/in_progress.webp';
import scrollToPage from '../../../utils/ScrollToLink';
import { Location, NavigateFunction } from 'react-router-dom';

const InProgress = ({
  location,
  navigate,
}: {
  location: Location;
  navigate: NavigateFunction;
}) => {
  return (
    <div id={Constants.INPROGRESS} className='inprogress'>
      <div className='inprogress_container container'>
        <div className='inprogress_container_text'>
          <h2 data-aos='fade-up' className='title_underline_light'>
            PROJEKT U IZGRADNJI
          </h2>
          <p data-aos='fade-up' data-aos-delay='50'>
            U izgradnji je stambeno-poslovni objekt koji će se sastojati od
            dvije etaže podzemnih garaža koja će biti povezana direktno sa
            stanovima pomoću dizala, prizemlja, 4 kata i nadgrađa sa ukupno 168
            stanova. U ponudi su garsonjera, jednosobni, dvosobni i trosobni
            stanovi te penthouse sa predivnom krovnom terasom.
          </p>
          <p data-aos='fade-up' data-aos-delay='100'>
            Zgrada je energetskog razreda A
          </p>
          <p data-aos='fade-up' data-aos-delay='150'>
            Stanovi i poslovni prostori se prodaju bez agencijske provizije i
            bez dodatnih poreza.
          </p>
          <div
            data-aos='fade-up'
            data-aos-delay='200'
            className='button'
            onClick={() =>
              scrollToPage(Constants.INPROGRESS_PAGE, location, navigate, true)
            }
          >
            <div className='opacity_transition_low'>PRIKAŽI VIŠE</div>
          </div>
        </div>
        <div data-aos='fade-left' className='inprogress_container_img'>
          <div>
            <img src={image} alt='in finished home' />
          </div>
        </div>
      </div>
    </div>
  );
};
export default InProgress;
